
const Footer = () => {
  return (
    <div className="calendar-footer"></div>
  );
};

export default Footer;